import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { UserVerificationBridgeService } from "@modules/+new/payments/shared-payments/components/user-verification/domain/+state/user-verification-bridge.service";
import { SharedPaymentRoutes } from "@modules/+new/payments/shared-payments/shared-payment-routing.module";

@Injectable({
	providedIn: "root"
})
export class VerifiedUserGuard {
	public constructor(
		private readonly userVerificationBridge: UserVerificationBridgeService,
		private readonly router: Router
	) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (!this.userVerificationBridge.isVerified()) {
			this.router.navigate([
				{ outlets: { modal: [SharedPaymentRoutes.BaseRoute, SharedPaymentRoutes.UserVerification] } }
			]);
			return false;
		}

		return true;
	}
}
